import "./App.css";
// import Video from "./components/Video/Video";
import FullVideo from "./components/FullscreenVideo/FullscrennVideo";
//import ButtonVideo from "./components/ButtonVideo/ButtonVideo";

function App() {
  return (
    <>
      {/* <Video /> */}
      <FullVideo />
      {/* <ButtonVideo />*/}
    </>
  );
}

export default App;
